export const templateThemes = {
  BeautyProducts: ["light", "pastel", "sakura"],
  GymTemplate: [
    "light",
    "dark",
    "ocean",
    "forest",
    "sunset",
    "midnight",
    "pastel",
    "desert",
    "lava",
    "sakura",
  ],
  "RestaurantTemplate-1": [
    "light",
    "sunset",
    "midnight",
    "desert",
    "lava",
    "Sky Blue",
    "Soft Green",
  ],
  "PortfolioTemplate-1": [
    "dark",
    "ocean",
    "forest",
    "sunset",
    "midnight",
    "desert",
    "lava",
  ],

  "CoachingClassesTemplate": [
    "Success Green Academy",
    "Royal Purple Prestige",
    "Modern Teal Innovation",
    "Amber Authority",
    "Midnight Slate Premium"
  ],

  "ConsultantTemplate": [
    "Royal Indigo",
    "Ocean Teal",
    "Prosperity Emerald",
    "Midnight Slate",
    "Crimson Authority"
  ],

  "HotelTemplate": [
    "Luxury Sapphire",
    "Emerald Forest",
    "Midnight Teal",
    "Deep Violet Prestige",
    "Prussian Blue Elite"
  ],

  "CafeTemplate-1": [
    "Mint Modern",
    "Charcoal Industrial",
    "Ocean Brew",
    "Rosewood Blush",
    "Olive Grove"
  ],

  "Salon-1": [
    "Rose Gold Modern",
    "Sage Serenity",
    "Platinum Modern",
    "Amethyst Prestige"
  ],

  // Wedding Invitation Themes
  "WeddingInvitationTemplate-1": [
    "Forest & Ivory",
    "Dusty Rose & Gold",
    "Navy & Gold",
    "Terracotta & Cream",
    "Burgundy & Blush",
    "Eucalyptus & White",
    "Indigo & Cream"
  ],

  // Yoga Classes Themes
  "YogaTemplate-1": [
    "Warm Mocha",
    "Lavender Mist",
    "Cool Slate",
    "Golden Sands",
    "Rose Quartz",
    "Modern Gray",
    "Forest Sage",
    "Terracotta Zen",
    "Honey Gold"
  ],

  // Fashion Designer Themes
  "FashionDesignerTemplate-1": [
    "Slate Blue Modern",
    "Monochrome Red",
    "Warm Terracotta",
    "Purple Violet",
    "Amber Luxe",
    "Bold Crimson"
  ],

  // TravelX Themes
  "TravelAgencyTemplate-1": [
    "Forest Explorer",
    "Sunset Safari",
    "Mystic Voyage",
    "Tropical Paradise",
    "Twilight Journey",
    "Coral Escape",
    "Golden Desert",
    "Ocean Breeze",
    "Rainforest Trail"
  ],

  "InteriorDesignerTemplate": [
    "Warm Walnut & Ivory",
    "Nordic Slate",
    "Sapphire Luxe",
    "Dusty Rose",
    "Burgundy & Sand"
  ]
};

export const colorThemes = {
  light: {
    "--dark": "#2c3e50",
    "--light": "#ecf0f1",
    "--accent-1": "#3498db",
    "--accent-2": "#2980b9",
    "--accent-3": "#1abc9c",
    "--accent-4": "#16a085",
    "--accent-5": "#f39c12",
  },
  dark: {
    "--dark": "#1a1a1a",
    "--light": "#ffffff",
    "--accent-1": "#bb86fc",
    "--accent-2": "#03dac6",
    "--accent-3": "#cf6679",
    "--accent-4": "#018786",
    "--accent-5": "#ff7597",
  },
  ocean: {
    "--dark": "#0a192f",
    "--light": "#ccd6f6",
    "--accent-1": "#64ffda",
    "--accent-2": "#112240",
    "--accent-3": "#233554",
    "--accent-4": "#8892b0",
    "--accent-5": "#52dbb7",
  },
  forest: {
    "--dark": "#1a2f1a",
    "--light": "#f0f7f0",
    "--accent-1": "#4caf50",
    "--accent-2": "#2e7d32",
    "--accent-3": "#81c784",
    "--accent-4": "#388e3c",
    "--accent-5": "#a5d6a7",
  },
  sunset: {
    "--dark": "#2d1b2e",
    "--light": "#f8f0e3",
    "--accent-1": "#ff6b6b",
    "--accent-2": "#ff8e6b",
    "--accent-3": "#ffaf6b",
    "--accent-4": "#ffd56b",
    "--accent-5": "#6bffd5",
  },
  midnight: {
    "--dark": "#0d0d1a",
    "--light": "#e0e0f8",
    "--accent-1": "#6a0dad",
    "--accent-2": "#3a0ca3",
    "--accent-3": "#7209b7",
    "--accent-4": "#4361ee",
    "--accent-5": "#b5179e",
  },
  pastel: {
    "--dark": "#444444",
    "--light": "#fefefe",
    "--accent-1": "#ffb3c1",
    "--accent-2": "#b5ead7",
    "--accent-3": "#c7ceea",
    "--accent-4": "#ffdac1",
    "--accent-5": "#e2f0cb",
  },
  desert: {
    "--dark": "#4b2e2e",
    "--light": "#fdf6e3",
    "--accent-1": "#e07a5f",
    "--accent-2": "#f2cc8f",
    "--accent-3": "#81b29a",
    "--accent-4": "#3d405b",
    "--accent-5": "#f4a261",
  },
  lava: {
    "--dark": "#1b0b0b",
    "--light": "#fceeee",
    "--accent-1": "#ff0000",
    "--accent-2": "#ff4500",
    "--accent-3": "#ff6347",
    "--accent-4": "#ffa07a",
    "--accent-5": "#ffe4b5",
  },
  sakura: {
    "--dark": "#2e1f27",
    "--light": "#fff0f5",
    "--accent-1": "#f9c5d1",
    "--accent-2": "#f7a1c4",
    "--accent-3": "#e08dac",
    "--accent-4": "#b46a8d",
    "--accent-5": "#fce4ec",
  },

  "Sky Blue": {
    "--dark": "#1B262C",
    "--light": "#BBE1FA",
    "--accent-1": "#00ADB5",
    "--accent-2": "#0F4C75",
    "--accent-3": "#112D4E",
    "--accent-4": "#003049",
    "--accent-5": "#427EF5",
  },

  "Soft Green": {
    "--dark": "#020202",
    "--light": "#b7efc5",
    "--accent-1": "#058c42",
    "--accent-2": "#04471c",
    "--accent-3": "#0d2818",
    // "--accent-4": "#003049",
    // "--accent-5": "#427EF5",
  },

  // Coaching Classes Themes

  "Success Green Academy": {
    "--light": "#ffffff",
    "--dark": "#1a2e1a",
    "--accent-1": "#2d6a4f",
    "--accent-2": "#52b788",
    "--accent-3": "#1b4332",
    "--accent-4": "#40916c",
    "--accent-5": "#d8f3dc",
  },

  "Royal Purple Prestige": {
    "--light": "#ffffff",
    "--dark": "#1e1433",
    "--accent-1": "#5b21b6",
    "--accent-2": "#8b5cf6",
    "--accent-3": "#3b0764",
    "--accent-4": "#7c3aed",
    "--accent-5": "#ddd6fe",
  },

  "Modern Teal Innovation": {
    "--light": "#ffffff",
    "--dark": "#0c2d3a",
    "--accent-1": "#0e7490",
    "--accent-2": "#06b6d4",
    "--accent-3": "#164e63",
    "--accent-4": "#0891b2",
    "--accent-5": "#cffafe",
  },

  "Amber Authority": {
    "--light": "#ffffff",
    "--dark": "#1c1410",
    "--accent-1": "#c2410c",
    "--accent-2": "#f97316",
    "--accent-3": "#7c2d12",
    "--accent-4": "#ea580c",
    "--accent-5": "#fed7aa",
  },

  "Midnight Slate Premium": {
    "--light": "#ffffff",
    "--dark": "#0f1419",
    "--accent-1": "#334155",
    "--accent-2": "#64748b",
    "--accent-3": "#1e293b",
    "--accent-4": "#475569",
    "--accent-5": "#e2e8f0",
  },

  // CA Themes

  "Prosperity Emerald": {
    "--dark": "#1a3329",
    "--light": "#ffffff",
    "--accent-1": "#86efac",
    "--accent-2": "#166534",
    "--accent-3": "#22c55e",
    "--accent-4": "#16a34a",
  },

  "Royal Indigo": {
    "--dark": "#1e1b4b",
    "--light": "#ffffff",
    "--accent-1": "#c4b5fd",
    "--accent-2": "#4338ca",
    "--accent-3": "#818cf8",
    "--accent-4": "#6366f1",
  },

  "Ocean Teal": {
    "--dark": "#134e4a",
    "--light": "#ffffff",
    "--accent-1": "#5eead4",
    "--accent-2": "#115e59",
    "--accent-3": "#14b8a6",
    "--accent-4": "#0d9488",
  },

  "Midnight Slate": {
    "--dark": "#0f172a",
    "--light": "#ffffff",
    "--accent-1": "#cbd5e1",
    "--accent-2": "#1e293b",
    "--accent-3": "#64748b",
    "--accent-4": "#475569",
  },

  "Crimson Authority": {
    "--dark": "#1c0f13",
    "--light": "#ffffff",
    "--accent-1": "#fca5a5",
    "--accent-2": "#991b1b",
    "--accent-3": "#ef4444",
    "--accent-4": "#dc2626",
  },

  "Deep Violet Prestige": {
    "--dark": "#2E1065",
    "--light": "#FFFFFF",
    "--accent-1": "#6B21A8",
    "--accent-2": "#581C87",
    "--accent-3": "#A855F7",
    "--accent-4": "#D8B4FE",
    "--accent-5": "#FAF5FF"
  },

  "Emerald Forest": {
    "--dark": "#14532D",
    "--light": "#FFFFFF",
    "--accent-1": "#15803D",
    "--accent-2": "#166534",
    "--accent-3": "#22C55E",
    "--accent-4": "#86EFAC",
    "--accent-5": "#F0FDF4"
  },

  "Midnight Teal": {
    "--dark": "#164E63",
    "--light": "#FFFFFF",
    "--accent-1": "#0E7490",
    "--accent-2": "#155E75",
    "--accent-3": "#06B6D4",
    "--accent-4": "#67E8F9",
    "--accent-5": "#ECFEFF"
  },

  "Prussian Blue Elite": {
    "--dark": "#0C2340",
    "--light": "#FFFFFF",
    "--accent-1": "#0F4C81",
    "--accent-2": "#1A5490",
    "--accent-3": "#2E7DAF",
    "--accent-4": "#7FB3D5",
    "--accent-5": "#EBF5FB"
  },

  // Cafe Themes

  "Mint Modern": {
    "--light": "#ffffff",
    "--dark": "#1a3a2e",
    "--accent-1": "#2d5f4f",
    "--accent-2": "#87c5b3",
    "--accent-3": "#3d6e5c",
    "--accent-4": "#f0f9f6",
    "--accent-5": "#5a8a76",
  },

  "Charcoal Industrial": {
    "--light": "#ffffff",
    "--dark": "#1c1c1c",
    "--accent-1": "#424242",
    "--accent-2": "#9e9e9e",
    "--accent-3": "#616161",
    "--accent-4": "#f5f5f5",
    "--accent-5": "#757575",
  },

  "Ocean Brew": {
    "--light": "#f0f8ff",
    "--dark": "#1b4965",
    "--accent-1": "#5fa8d3",
    "--accent-2": "#bee9e8",
    "--accent-3": "#3a7ca5",
    " --accent-4": "#e8f4f8",
    "--accent-5": "#62b6cb",
  },

  "Rosewood Blush": {
    "--light": "#fff0f5",
    "--dark": "#4a1942",
    "--accent-1": "#c1666b",
    "--accent-2": "#e4c1f9",
    "--accent-3": "#8b2f4e",
    "--accent-4": "#fef8ff",
    "--accent-5": "#a05c7b"
  },

   "Olive Grove": {
    "--light": "#f5f3ee",
    "--dark": "#2f3e2b",
    "--accent-1": "#5f7a61",
    "--accent-2": "#9eb384",
    "--accent-3": "#435740",
    "--accent-4": "#f9f7f3",
    "--accent-5": "#7d8f7c"
  },

  // Hair Salon Themes

  "Rose Gold Modern": {
    "--light": "#FFF9F7",
    "--dark": "#2C1E1A",
    "--accent-1": "#9D6B6B",
    "--accent-2": "#7D5555",
    "--accent-3": "#F5E6E6",
    "--accent-4": "#5A4040",
    "--accent-5": "#FFFFFF"
  },

  "Sage Serenity": {
    "--light": "#F7F9F5",        
    "--dark": "#2A2E24",        
    "--accent-1": "#5C7A4E",    
    "--accent-2": "#4A5F40",    
    "--accent-3": "#E8EDE4",    
    "--accent-4": "#4A5240",    
    "--accent-5": "#FFFFFF"    
  },

  "Platinum Modern": {
    "--light": "#F8F9FA",
    "--dark": "#1C1E22",
    "--accent-1": "#6B7078",
    "--accent-2": "#565A62",
    "--accent-3": "#E8EAED",
    "--accent-4": "#4A4D56",
    "--accent-5": "#FFFFFF"
  },

  "Amethyst Prestige": {
    "--light": "#FAF8FB",
    "--dark": "#2A1E2E",
    "--accent-1": "#7D5F7D",
    "--accent-2": "#634D63",
    "--accent-3": "#F0E8F0",
    "--accent-4": "#5A4A5A",
    "--accent-5": "#FFFFFF",
  },

  // Wedding Invitation Themes

  "Forest & Ivory": {
    "--light": "#FAFAF6",
    "--dark": "#1B2E1B",
    "--accent-1": "#2D5A3D",
    "--accent-2": "#4A7C5A",
    "--accent-3": "#1E3D28",
    "--accent-4": "#F0F2EB",
    "--accent-5": "#234530"
  },

  "Dusty Rose & Gold": {
    "--light": "#FFFBF8",
    "--dark": "#2E2628",
    "--accent-1": "#8B5A5A",
    "--accent-2": "#A87070",
    "--accent-3": "#6B4A42",
    "--accent-4": "#F5EFEC",
    "--accent-5": "#704848"
  },

  "Navy & Gold": {
    "--light": "#FDFCF9",
    "--dark": "#1E2A3A",
    "--accent-1": "#C9A86C",
    "--accent-2": "#D4C4A8",
    "--accent-3": "#4A6485",
    "--accent-4": "#F5F3EE",
    "--accent-5": "#8B7355"
  },

  "Terracotta & Cream": {
    "--light": "#FFFCF7",
    "--dark": "#3A3230",
    "--accent-1": "#C4896A",
    "--accent-2": "#D4A88C",
    "--accent-3": "#D4C4A8",
    "--accent-4": "#F5EDE6",
    "--accent-5": "#9B6B55"
  },

  "Burgundy & Blush": {
    "--light": "#FFFAF8",
    "--dark": "#2E2225",
    "--accent-1": "#8B4A55",
    "--accent-2": "#D4A8B0",
    "--accent-3": "#C9A87C",
    "--accent-4": "#F5EFEC",
    "--accent-5": "#6B3540"
  },

  "Eucalyptus & White": {
    "--light": "#FDFFFE",
    "--dark": "#2A3532",
    "--accent-1": "#6B8B7A",
    "--accent-2": "#9BB0A0",
    "--accent-3": "#C4D4C8",
    "--accent-4": "#EEF3F0",
    "--accent-5": "#4A6B5A"
  },

  "Indigo & Cream": {
    "--light": "#F9F8F5",
    "--dark": "#1E1B4B",
    "--accent-1": "#4338CA",
    "--accent-2": "#A5B4FC",
    "--accent-3": "#334155",
    "--accent-4": "#EEF2FF",
    "--accent-5": "#3730A3"
  },

  // Yoga Classes Themes

  "Warm Mocha": {
    "--light": "#FAF6F1",
    "--dark": "#2E2420",
    "--accent-1": "#8B7355",
    "--accent-2": "#C4A896",
    "--accent-3": "#D4A574",
    "--accent-4": "#B88A6F",
    "--accent-5": "#7D5E4A"
  },

  "Lavender Mist": {
    "--light": "#F9F7FA",
    "--dark": "#2A2230",
    "--accent-1": "#7D6B7A",
    "--accent-2": "#B5A4B8",
    "--accent-3": "#CC92B7",
    "--accent-4": "#A88D9C",
    "--accent-5": "#6B5A68"
  },

  "Cool Slate": {
    "--light": "#F5F8F9",
    "--dark": "#1E2628",
    "--accent-1": "#6B7A7E",
    "--accent-2": "#95B5BA",
    "--accent-3": "#93AEB3",
    "--accent-4": "#8FA8AD",
    "--accent-5": "#527A84"
  },

  "Golden Sands": {
    "--light": "#FBF8F3",
    "--dark": "#2A2218",
    "--accent-1": "#8B7353",
    "--accent-2": "#C9B896",
    "--accent-3": "#D9A854",
    "--accent-4": "#B8945E",
    "--accent-5": "#7D6642"
  },

  "Rose Quartz": {
    "--light": "#FDF8F9",
    "--dark": "#2E2024",
    "--accent-1": "#8B6B70",
    "--accent-2": "#D4B8BE",
    "--accent-3": "#D5768C",
    "--accent-4": "#C49AA5",
    "--accent-5": "#7A5A5F"
  },

  "Modern Gray": {
    "--light": "#F8F9FA",
    "--dark": "#1C1E22",
    "--accent-1": "#6B7078",
    "--accent-2": "#B4B8BE",
    "--accent-3": "#ABB3BE",
    "--accent-4": "#9DA2A8",
    "--accent-5": "#5A5F66"
  },

  "Forest Sage": {
    "--light": "#F6F8F5",
    "--dark": "#242E24",
    "--accent-1": "#5F6E5A",
    "--accent-2": "#8FA888",
    "--accent-3": "#8CB17A",
    "--accent-4": "#7A9270",
    "--accent-5": "#4A5F45"
  },

  "Terracotta Zen": {
    "--light": "#FAF6F2",
    "--dark": "#2A2018",
    "--accent-1": "#8B6852",
    "--accent-2": "#C4A890",
    "--accent-3": "#D49A6A",
    "--accent-4": "#B8876E",
    "--accent-5": "#7A5840"
  },

  "Honey Gold": {
    "--light": "#FBF9F4",
    "--dark": "#2A2418",
    "--accent-1": "#8B7652",
    "--accent-2": "#C9B490",
    "--accent-3": "#D9B870",
    "--accent-4": "#B89A68",
    "--accent-5": "#7A6640"
  },

  // Fashion Designer Themes

  "Slate Blue Modern": {
    "--light": "#F8FAFC",
    "--dark": "#0F172A",
    "--accent-1": "#2563EB",
    "--accent-2": "#475569",
    "--accent-3": "#94A3B8",
    "--accent-4": "#1E293B",
    "--accent-5": "#E2E8F0"
  },

  "Monochrome Red": {
    "--light": "#FFFFFF",
    "--dark": "#111111",
    "--accent-1": "#FF3B30",
    "--accent-2": "#555555",
    "--accent-3": "#CCCCCC",
    "--accent-4": "#1A1A1A",
    "--accent-5": "#F2F2F2"
  },

  "Warm Terracotta": {
    "--light": "#FFF4EC",
    "--dark": "#2B1A12",
    "--accent-1": "#E76F51",
    "--accent-2": "#8C5A3C",
    "--accent-3": "#E9C9A9",
    "--accent-4": "#3B2418",
    "--accent-5": "#F6E3D3"
  },

  "Purple Violet": {
    "--light": "#F8F8F8",
    "--dark": "#111111",
    "--accent-1": "#6D28D9",
    "--accent-2": "#525252",
    "--accent-3": "#D4D4D4",
    "--accent-4": "#1C1C1C",
    "--accent-5": "#F0F0F0"
  },

  "Amber Luxe": {
    "--light": "#FDF8F2",
    "--dark": "#1E0F05",
    "--accent-1": "#B45309",
    "--accent-2": "#6B4C3B",
    "--accent-3": "#E8C9A8",
    "--accent-4": "#2D1507",
    "--accent-5": "#FAF0E4"
  },

  "Bold Crimson": {
    "--light": "#FFFFFF",
    "--dark": "#0A0A0A",
    "--accent-1": "#FF2D2D",
    "--accent-2": "#4A4A4A",
    "--accent-3": "#D6D6D6",
    "--accent-4": "#121212",
    "--accent-5": "#F5F5F5"
  },

  // TravelX Themes

  "Forest Explorer": {
    "--light": "#FAFBFC",
    "--dark": "#0F172A",
    "--accent-1": "#10B981",
    "--accent-2": "#F59E0B",
    "--accent-3": "#E2E8F0",
    "--accent-4": "#059669",
    "--accent-5": "#64748B"
  },

  "Sunset Safari": {
    "--light": "#FAFBFC",
    "--dark": "#0F172A",
    "--accent-1": "#EF4444",
    "--accent-2": "#F97316",
    "--accent-3": "#E2E8F0",
    "--accent-4": "#DC2626",
    "--accent-5": "#64748B"
  },

  "Mystic Voyage": {
    "--light": "#FAFBFC",
    "--dark": "#0F172A",
    "--accent-1": "#8B5CF6",
    "--accent-2": "#EC4899",
    "--accent-3": "#E2E8F0",
    "--accent-4": "#7C3AED",
    "--accent-5": "#64748B"
  },

  "Tropical Paradise": {
    "--light": "#FAFBFC",
    "--dark": "#0F172A",
    "--accent-1": "#14B8A6",
    "--accent-2": "#F59E0B",
    "--accent-3": "#E2E8F0",
    "--accent-4": "#0D9488",
    "--accent-5": "#64748B"
  },

  "Twilight Journey": {
    "--light": "#FAFBFC",
    "--dark": "#0F172A",
    "--accent-1": "#6366F1",
    "--accent-2": "#F97316",
    "--accent-3": "#E2E8F0",
    "--accent-4": "#4F46E5",
    "--accent-5": "#64748B"
  },

  "Coral Escape": {
    "--light": "#FAFBFC",
    "--dark": "#0F172A",
    "--accent-1": "#F43F5E",
    "--accent-2": "#A855F7",
    "--accent-3": "#E2E8F0",
    "--accent-4": "#E11D48",
    "--accent-5": "#64748B"
  },

  "Golden Desert": {
    "--light": "#FAFBFC",
    "--dark": "#0F172A",
    "--accent-1": "#F59E0B",
    "--accent-2": "#3B82F6",
    "--accent-3": "#E2E8F0",
    "--accent-4": "#D97706",
    "--accent-5": "#64748B"
  },

  "Ocean Breeze": {
    "--light": "#FAFBFC",
    "--dark": "#0F172A",
    "--accent-1": "#06B6D4",
    "--accent-2": "#F97316",
    "--accent-3": "#E2E8F0",
    "--accent-4": "#0891B2",
    "--accent-5": "#64748B"
  },

  "Rainforest Trail": {
    "--light": "#FAFBFC",
    "--dark": "#0F172A",
    "--accent-1": "#059669",
    "--accent-2": "#F59E0B",
    "--accent-3": "#E2E8F0",
    "--accent-4": "#047857",
    "--accent-5": "#64748B"
  },

  // Interior Designer Themes

  "Warm Walnut & Ivory": {
    "--light": "#faf8f4",
    "--dark": "#1c1410",
    "--accent-1": "#8b6b3d",
    "--accent-2": "#6b4f28",
    "--accent-3": "#a88558",
    "--accent-4": "#3d2a14",
    "--accent-5": "#f5f0e8"
  },

  "Nordic Slate": {
    "--light": "#f8f9fb",
    "--dark": "#1a1e24",
    "--accent-1": "#5a6e7a",
    "--accent-2": "#3e5260",
    "--accent-3": "#7a8e9a",
    "--accent-4": "#2a3540",
    "--accent-5": "#edf2f5"
  },

  "Sapphire Luxe": {
    "--light": "#f7f9fc",
    "--dark": "#0d1b2e",
    "--accent-1": "#1a4a7a",
    "--accent-2": "#0f3560",
    "--accent-3": "#2d6aad",
    "--accent-4": "#091828",
    "--accent-5": "#eaf2fb"
  },

  "Dusty Rose": {
    "--light": "#fdf9f8",
    "--dark": "#2a1e1e",
    "--accent-1": "#9d6b6b",
    "--accent-2": "#7d5252",
    "--accent-3": "#b58888",
    "--accent-4": "#3a2424",
    "--accent-5": "#f7eded"
  },

  "Burgundy & Sand": {
    "--light": "#faf8f4",
    "--dark": "#2a1218",
    "--accent-1": "#7d2e3e",
    "--accent-2": "#5a1e2c",
    "--accent-3": "#a04e5e",
    "--accent-4": "#3a1520",
    "--accent-5": "#f5ece8"
  }
};

export const fontThemes = {
  modern: {
    "--font-primary": "Inter, sans-serif",
    "--font-heading": "Poppins, sans-serif",
  },
  classic: {
    "--font-primary": "Georgia, serif",
    "--font-heading": "Playfair Display, serif",
  },
  minimal: {
    "--font-primary": "Helvetica, sans-serif",
    "--font-heading": "Helvetica, sans-serif",
  },
  elegant: {
    "--font-primary": "Lora, serif",
    "--font-heading": "Cormorant Garamond, serif",
  },
  tech: {
    "--font-primary": "Roboto Mono, monospace",
    "--font-heading": "Roboto Mono, monospace",
  },
};
